<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M82.5-82.5V-559l275-117v79.5l200-80v119h320v475h-795Zm75-75h645v-324.78h-320v-83.22l-200 80V-564l-125 55.5v351Zm285-85h75v-155h-75v155Zm-160 0h75v-155h-75v155Zm320 0h75v-155h-75v155Zm275-315H682L722.5-875h115l40 317.5Zm-720 400h645-645Z"/></svg>
</template>
